import {parseNumber} from '@benchling/js-utils';

import {DataFrameColumnDef} from 'data-frames/DataFrameTypes';
import {LeafType} from 'data-types/benchling-type-def/BenchlingTypeDef';
import {JSONValue} from 'util/Types';

/**
 * Return whether a cellValue should be considered convertible to a JS Number.
 *
 * - cellValue='1.2', column leafType=FLOAT -> true
 * - cellValue='1', column leafType=INTEGER -> false
 * - cellValue=1, column leafType=* -> true
 */
export default function isNumericCellValue(cellValue: JSONValue, column: DataFrameColumnDef): boolean {
  return (
    typeof cellValue === 'number' ||
    (column.type.leafType === LeafType.DECIMAL &&
      typeof cellValue === 'string' &&
      parseNumber(cellValue) != null)
  );
}
